var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app",staticStyle:{"background":"#e7eaeb"},style:(this.$customStyle)},[_c('v-overlay',{attrs:{"color":"primary","opacity":".6","value":_vm.loading,"z-index":"1000"}},[_c('Logo')],1),_c('router-view',{on:{"AccessDenied":_vm.showErrorAlert}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }